import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vc-detail-list',
  templateUrl: './detail-list.component.html',
  styleUrl: './detail-list.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VcDetailListComponent {

}
